import React, { Component } from "react";
import { Route } from "react-router-dom";
import ReactGA from "react-ga";
import Login from "./Login";
import Home from "./Home";
import ListPage from "./2/ListPage";
import Header from "./2/Header";
import "./2/style.css";
import Posts from "./Post/Posts";
import Post from "./Post/Post";
// import Register from './Register'
import Registration from "./Settings/Registration";
import AuthenticatedComponent from "./AuthenticatedComponent";
import Product from "./Catalogue/Product";
import ProductQuickEdit from "./Catalogue/ProductQuickEdit";
import PincodeProductQuickEdit from "./Pincode/PincodeProductQuickEdit";
import ProductImageUpload from "./Catalogue/ProductImageUpload";
import FoodDeliveryPlatformProducts from "./Catalogue/FoodDeliveryPlatformProducts";
import Customer from "./CRM/Customer";
import Sales from "./Sales/Sales";
import SalesIntermediate from "./Sales/SalesIntermediate";
import CashRegisterClosing from "./Sales/CashRegisterClosing";
import ReceivePayment from "./Sales/ReceivePayment";
import DeliveryList from "./Sales/DeliveryList";
import WhatsAppOrders from "./Sales/WhatsAppOrders";
import DeliveryListNew from "./Sales/DeliveryListNew";
import InventoryIntermediate from "./Inventory/InventoryIntermediate";
import Inventory from "./Inventory/Inventory";
import ViewInventory from "./Inventory/ViewInventory";
import ViewSales from "./Sales/ViewSales";
import LocationList from "./Settings/LocationList";
import AddEditStore from "./Settings/AddEditStore";
import ViewStoreDetails from "./Settings/ViewStoreDetails";
import AddEditEmployee from "./Settings/Employee/AddEditEmployee";
import ViewEmployeeDetails from "./Settings/Employee/ViewEmployeeDetails";
import CustomFields from "./Settings/CustomFields";
import PrintConfigList from "./Settings/PrintConfigList";
import PrintConfigListNew from "./Settings/PrintConfigListNew";
import PrintConfig from "./Settings/PrintConfig";
import PrintTemplateTypes from "./Settings/PrintTemplates/PrintTemplateTypes";
import PrintTemplateGallery from "./Settings/PrintTemplates/PrintTemplateGallery";
import PrintTemplateCustomize from "./Settings/PrintTemplates/PrintTemplateCustomize";
import AddEditVendor from "./Settings/Vendor/AddEditVendor";
import CustomerReferenceDetail from "./Reports/CustomerReferenceDetail";
import CustomerDashboard from "./Reports/CustomerDashboard";
import SalesDashboard from "./Reports/SalesDashboard";
import Dashboard from "./Reports/Dashboard";
import DashboardSettings from "./Reports/DashboardSettings";
import BillWiseDetail from "./Reports/BillWiseDetail";
import ItemSoldReport from "./Reports/ItemSoldReport";
import InvoiceDetail from "./Reports/InvoiceDetail";
import EmployeeItemReport from "./Reports/EmployeeItemReport";
import CategoryWiseDetail from "./Reports/CategoryWiseDetail";
import BrandWiseDetail from "./Reports/BrandWiseDetail";
import SubCategoryWiseDetail from "./Reports/SubCategoryWiseDetail";
import ProductTypeWise from "./Reports/ProductTypeWise";
import AllReport from "./Reports/AllReport";
import EmployeeDashboard from "./Reports/EmployeeDashboard";
import ExpenseListReport from "./Reports/ExpenseListReport";
import ExpenseByExpenseCategoryReport from "./Reports/ExpenseByExpenseCategoryReport";
import ExpenseByPartyReport from "./Reports/ExpenseByParty";
import Instock from "./Reports/InStockReport";
import ItemLedger from "./Reports/ItemLedger";
import DailySalesReport from "./Reports/DailySalesReport";
import MonthlySalesReport from "./Reports/MonthlySalesReport";
import PaymentModeWise from "./Reports/PaymentModeWise";
import EmployeeWorkSheet from "./Reports/EmployeeWorkSheet";
import PaymentModeTransactionTypeReport from "./Reports/PaymentModeTransactionTypeReport";
import InvoiceDetail1 from "./Reports/InvoiceDetail1";
import AllInventoryReport from "./Reports/AllInventoryReport";
import CustomerWalletLedgerReport from "./Reports/CustomerWalletLedgerReport";
import CustomerOutstandingLedgerReport from "./Reports/CustomerOutstandingLedgerReport";
import WalletLedger from "./Reports/WalletLedger";
import OutStandingLedger from "./Reports/OutStandingLedger";
import UniqueNoReport from "./Reports/UniqueNoReport";
import UniqueNoLedger from "./Reports/UniqueNoLedger";
import SalesTransactionView from "./Public/SalesTransactionView";
import EditPackage from "./Packages/EditPackage";
import BarcodePrintSettings from "./Settings/BarcodePrintSettings";
import BarcodePrint from "./Inventory/BarcodePrint";
import AddTransaction from "./Account/AddTransaction";
import VendorLedger from "./Reports/VendorLedger";
import VendorOutstanding from "./Reports/VendorOutstanding";
import LoyaltySetup from "./Loyalty/LoyaltySetup";
import AddEditLoyalty from "./Loyalty/AddEditLoyaltyType";
import MembershipExpiry from "./Reports/MembershipExpiry";
import CustomerReferralProgram from "./Referral/CustomerReferralProgram";
import CaptureCustomerReferral from "./Referral/CaptureCustomerReferral";
import Survey from "./Survey/Survey";
import TopCustomers from "./Reports/TopCustomers";
import LoyaltyByCustomer from "./Reports/LoyaltyByCustomer";
import LoyaltyLedger from "./Reports/LoyaltyLedger";
import LoyaltyDashboard from "./Loyalty/LoyaltyDashboard";
import InventoryHistory from "./Reports/InventoryHistory";
import ProductOrderReport from "./Reports/ProductOrderReport";
import CashRegisterSetup from "./Settings/CashRegisterSetup";
import AppointmentView from "./Appointment/AppointmentView";
import AppointmentList from "./Appointment/AppointmentList";
import CreateUpdateAppointment from "./Appointment/CreateUpdateAppointmentNew";
import CreateAppointmentBooking from "./Appointment/CreateAppointmentBooking";
import GSTR2Report from "./Reports/GSTR2Report";
import MembershipDashboard from "./Reports/MembershipDashboard";
import MinQtyReport from "./Reports/MinQtyReport";
import MaxQtyReport from "./Reports/MaxQtyReport";
import ProductConsumption from "./Sales/ProductConsumption";
import ParkedTransaction from "./Common/ParkedTransaction";
import ProfitLossReport from "./Reports/ProfitLossReport";
import InvoiceDetail2 from "./Reports/InvoiceDetail2";
import GSTR1B2B from "./Reports/GSTR1B2B";
import GSTR1B2C from "./Reports/GSTR1B2C";
import GSTR1TransactionWise from "./Reports/GSTR1TransactionWise";
import GSTR2TransactionWise from "./Reports/GSTR2-TransactionWise";
import FoodDeliveryOrders from "./Sales/FoodDeliveryOrders";
import ViewIntransit from "./Sales/ViewIntransit";
import CampaignsToRun from "./CRM/CampaignsToRun";
import CampaignToRunCustomers from "./CRM/CampaignToRunCustomers";
import GenericRedirectPage from "./Common/GenericRedirectPage";
import ViewBusinessCard from "./CRM/ViewBusinessCard";
import EditBusinessCard from "./CRM/EditBusinessCard";
import CashRegisterList from "./Settings/CashRegisterList";
import CashRegisterPrinterSettings from "./Settings/CashRegisterPrinterSettings";
import CashRegisterPaymentProvider from "./Settings/CashRegisterPaymentProvider";
import CashRegisterPaymentProviderNewEdit from "./Settings/CashRegisterPaymentProviderNewEdit";
import ViewImageTemplates from "./CRM/ViewImageTemplates";
import EditImageTemplate from "./CRM/EditImageTemplate";
import ViewInquiries from "./Omni/OmniInquiries";
import OfferReport from "./Reports/OfferReport";
import OfferSummaryReport from "./Reports/OfferSummaryReport";
import OnBoarding from "./Settings/OnBoarding";
import AttendanceReport from "./Reports/AttendanceReport";
import KDS from "./KDS/KDS";
import KOTCustomerDisplay from "./KDS/KOTCustomerDisplay";
import BatchExpiryReport from "./Reports/BatchExpiryReport";
import OmniPayment from "./Omni/OmniPayment";
import OmniProfile from "./Omni/OmniProfile";
import OmniProductDetailsPage from "./Omni/OmniProductDetailsPage";
import BulkPurchaseReturn from "./Inventory/BulkPurchaseReturn";
// import OmniShippingList from './Omni/OmniShippingList';
// import OmniShippingEdit from './Omni/OmniShippingEdit';
import OmniSettings from "./Omni/OmniSettings";
import CustomerDisplay from "./CustomerDisplay/CustomerDisplay";
import CustomerDisplaySettings from "./CustomerDisplay/CustomerDisplaySettings";
import TableOrder from "./TableOrder/TableOrder";
import Tables from "./Settings/Tables";
import TablesNew from "./Settings/TablesNew";
import HSNWiseReport from "./Reports/HSNWiseReport";
import ForgotPassword from "./ForgotPassword";
import OmniHomeSectionEdit from "./Omni/OmniHomeSectionEdit";
import OmniTransactionCheck from "./Omni/OmniTransactionCheck";
import RESettings from "./Settings/RESettings";
import AddRegistrationSettings from "./Settings/AddRegistrationSettings";
import OmniMenu from "./Omni/OmniMenu";
import EmployeeIncentiveReport from "./Reports/EmployeeIncentiveReport";

import InventoryPurchaseSalesInStock from "./Reports/InventoryPurchaseSalesInStock";
import CategoryWiseTransactionReport from "./Reports/CategoryWiseTransactionReport";
import MissingPopularItems from "./Pincode/MissingPopularItems";
import TransactionReport from "./Reports/TransactionReport";
import ProductExport from "./Reports/ProductExport";
import PincodeOrderReport from "./Reports/PincodeOrderReport";
import PincodeItemReport from "./Reports/PincodeItemReport";
import PincodeCustomerReport from "./Reports/PincodeCustomerReport";
import PinCodeSignUpNew from "./Pincode/PincodeSignUpNew";
import OnlineOrdersInfinityApp from "./Sales/OnlineOrdersInfinityApp";
import PincodeIntegrationSettings from "./Pincode/PincodeIntegrationSettings";
import ProductPincode from "./Catalogue/ProductPincode";
import PincodeInStockDashboard from "./Reports/PincodeInStockDashboard";
import PincodeInstockReport from "./Reports/PincodeInstockReport";
import PincodeReportedProducts from "./Reports/PincodeReportedProducts";
import PincodeReportManual from "./Reports/PincodeReportManual";
import PincodeNotFoundInGC from "./Reports/PincodeNotFoundInGC";
import PincodeAdminDashboard from "./Pincode/PincodeAdminDashboard";
import PincodeSmartMerchantDashboard from "./Reports/PincodeSmartMerchantDashboard";
import MarginReport from "./Reports/MarginReport";
import NewRegistration from "./NewRegistration";
import PincodeSoldOutOfStock from "./Reports/PincodeSoldOutOfStock";
import PurchaseProjectionReport from "./Reports/PurchaseProjectionReport";
import InTransit from "./Inventory/InTransit";
import Packaging from "./Inventory/Packaging";
import OfferSmartProducts from "./Inventory/Offer";
import ExpiryVerification from "./Pincode/ExpiryVerification";
import PincodeSmartProductOffer from "./Pincode/PincodeSmartProductOffer";
import WHInboundVerification from "./Pincode/WHInboundVerification";
import PincodeWarehouseIntegration from "./Pincode/PincodeWarehouseIntegration";
import WHReturn from "./Pincode/WHReturn";
import PincodeMissingWHInbound from "./Pincode/PincodeMissingWHInbound";
import WHInboundVerificationView from "./Pincode/WHInboundVerificationView";
import WHReturnItemsView from "./Pincode/WHReturnItemsView";
import WHInboundList from "./Pincode/WHInboundList";
import Message from "./Reports/Message";
import CategoryList from "./Catalogue/CategoryList";
import SubCategoryList from "./Catalogue/SubCategoryList";
import BrandList from "./Catalogue/BrandList";
import TaxesList from "./Catalogue/TaxesList";
import ProductGroupList from "./Catalogue/ProductGroupList";
import OfferList from "./Catalogue/OfferList";
import BomList from "./Catalogue/BomList";
import ProductList from "./Catalogue/ProductList";
import SalesHistory from "./Sales/SalesHistory";
import CustomerList from "./CRM/CustomerList";
import CampaignList from "./CRM/CampaignList";
import MessageTemplateList from "./CRM/MessageTemplateList";
import MembershipList from "./CRM/MembershipList";
import CouponList from "./CRM/CouponList";
import LoyaltyTypeList from "./Loyalty/LoyaltyTypeList";
import AccountList from "./Account/AccountList";
import ExpenseCategoryList from "./Expenses/ExpenseCategoryList";
import AccountManagementList from "./Account/AccountManagementList";
import ExpenseList from "./Expenses/ExpenseList";
import AttendanceList from "./Attendance/AttendanceList";
import StaffList from "./Settings/Employee/StaffList";
import TransactionSMSTemplateList from "./2/Setup/TransactionSMSTemplateList";
import ModuleConfigurationList from "./2/Setup/ModuleConfigurationList";
import CustomRoleList from "./2/Setup/CustomRoleList";
import PaymentTypeList from "./2/Setup/PaymentTypeList";
import StoreList from "./2/Setup/StoreList";
import Menu from "./2/Menu";
import MobileTopBar from "./2/Controls/MobileTopBar";
import InventoryList from "./Inventory/InventoryList";
import VendorList from "./Settings/Vendor/VendorList";
import InventoryInTransit from "./Inventory/InventoryInTransit";
import Integration from "./2/Setup/Integration/Integration";
import WhatsAppPayment from "./2/Setup/Integration/WhatsAppPayment";
import Template from "./2/Setup/Integration/Template";
import CredentialVerify from "./2/Setup/Integration/CredentialVerify";
import PaymentCredentialsList from "./2/Setup/Integration/PaymentCredentialsList";
import LoyaltyCredentials from "./2/Setup/Integration/LoyaltyCredentials";
import Report from "./Reports/Report";
import DownloadedReports from "./Reports/DownloadedReports";
import LowStockReport from "./Reports/LowStockReport";
import OutOfStockReport from "./Reports/OutOfStockReport";
import NotificationBox from "./2/Controls/NotificationBox";
import {  messaging } from "../fcmFirebase";
import { isMobileApp } from "../CommonFunctions";
import CreateCampaign from "./CRM/Campaign/CreateCampaign";
import CampaignManage from "./CRM/Campaign/CampaignManage";
import HelpDeskConfiguration from "./HelpDesk/HelpDeskConfiguration";
import HelpDeskTypeList from "./HelpDesk/HelpDeskTypeList";
import TicketsList from "./HelpDesk/TicketsList";
import FeedBackCreation from "./Feedback/FeedBackCreation";
import MachineTrackerLedger from "./Reports/MachineTrackerLedger";
import SalesChannelList from "./2/Setup/SalesChannel/SalesChannelList";
import FeedbackTemplateList from "./Feedback/FeedbackTemplateList";
import FeedbackUser from "./Feedback/FeedbackUser";
import FeedbacksList from "./Feedback/FeedbacksList";
import FeedbackLinkDetail from "./Feedback/FeedbackLinkDetail";
class Main extends Component {
  constructor() {
    super();
    ReactGA.initialize("UA-135749742-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    this.state = {
      showNotificationBox: false,
      notificationData: null
    };

    // Bind methods
    this.stopSound = this.stopSound.bind(this);
    this.onClose = this.onClose.bind(this);
    this.audioRef = null;
  }

 
audioRef = null;

playNotificationSound = (audioUrl) => {
  if (this.audioRef) {
    this.audioRef.pause();
    this.audioRef.currentTime = 0;
  }
  
  this.audioRef = new Audio(audioUrl);
  // the Online Orders page plays its own sound only when this one has not played (see WhatsAppOrders.js)
  window.lastOrderAlertAt = Date.now();
  this.audioRef.play().catch(error => {
    console.error("Audio playback failed:", error);
  });
}



componentDidMount() {
  console.log("Component mounted");

  // Handle messages from Service Worker
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      console.log('Service Worker message received:', event);
      console.log('Service Worker message data:', event.data);
      
      // CORRECTED: Process the nested payload structure
      if (event.data && event.data.firebaseMessaging) {
        const fcmData = event.data.firebaseMessaging;
        console.log('FCM Data:', fcmData);
        
        // Check for payload in the nested structure
        if (fcmData.payload && fcmData.payload.data && fcmData.payload.data.payload) {
          try {
            const parsedData = JSON.parse(fcmData.payload.data.payload);

             if (parsedData.audioUrl) {
      this.playNotificationSound(parsedData.audioUrl);
    }
            console.log("Successfully parsed payload:", parsedData);
            this.setState({
              notificationData: parsedData,
              showNotificationBox: true,
            });
          } catch (e) {
            console.error("JSON parse error:", e);
            console.error("Failed to parse:", fcmData.payload.data.payload);
          }
        }
      }
    });
  } else {
    console.log('Service Worker not available');
  }

  console.log("messaging object:", messaging);
  // Handle foreground messages from FCM
  if (messaging && messaging.onMessage) {
    console.log("Setting up foreground listener");

    this.unsubscribe = messaging.onMessage((payload) => {
      console.log("Foreground message RAW payload:", JSON.stringify(payload));
      console.log("Foreground message received:", payload);

      // Check each property
      console.log("Has data?", payload.hasOwnProperty("data"));
      console.log("Has notification?", payload.hasOwnProperty("notification"));
      
      if (payload.data) {
        console.log("payload.data exists:", payload.data);
        console.log("payload.data.payload type:", typeof payload.data.payload);
        
        if (payload.data.payload) {
          console.log("payload.data.payload value:", payload.data.payload);
          try {
            const parsedData = JSON.parse(payload.data.payload);
            console.log("Successfully parsed payload:", parsedData);
            // dashboard open: the new order alert has its sound too (the background path above already plays it)
            if (parsedData.audioUrl) {
              this.playNotificationSound(parsedData.audioUrl);
            }
            this.setState({
              notificationData: parsedData,
              showNotificationBox: true,
            });
          } catch (e) {
            console.error("JSON parse error:", e);
            console.error("Failed to parse:", payload.data.payload);
          }
        }
      } else {
        console.log("No data property found");
      }
    });
  } else {
    console.error("Messaging not available - check FCM initialization");
  }
}

componentWillUnmount() {
  if (this.unsubscribe) {
    this.unsubscribe();
  }
}



  stopSound() {
    if (this.audioRef) {
      this.audioRef.pause();
      if (this.audioRef.currentTime) {
        this.audioRef.currentTime = 0;
      }
      this.audioRef = null;
    }
  }

  onClose() {
    this.stopSound();
    this.setState({
      showNotificationBox: false,
      notificationData: null
    });
  }
  


  render() {
    return (
      <>
        <div>
          <Route
            exact
            path="/"
            render={({ history }) => (
              <div>
                <Login {...this.props} onHistory={history} />
              </div>
            )}
          />
          <Route
            exact
            path="/forgotpassword"
            render={({ history }) => (
              <div>
                <ForgotPassword {...this.props} onHistory={history} />
              </div>
            )}
          />
            <Route
            exact
            path="/feedback/response/:id"
            render={(params) => (
              <div>
                <FeedbackUser {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/payment/payment-options/whatsapp"
            render={({ history }) => (
              <div>
                <WhatsAppPayment {...this.props} onHistory={history} />
              </div>
            )}
          />

           <Route
            exact
            path="/home/campaign/create"
            render={({ history }) => (
              <div>
                <CreateCampaign {...this.props} />
              </div>
            )}
          />

            <Route
            exact
            path="/home/feedback/template/create"
            render={({ history }) => (
              <div>
                <FeedBackCreation {...this.props} />
              </div>
            )}
          />
            <Route
            exact
            path="/home/feedback/template"
            render={({ history }) => (
              <div>
                <FeedbackTemplateList {...this.props} />
              </div>
            )}
          />
           <Route
            exact
            path="/home/feedbacks"
            render={({ history }) => (
              <div>
                <FeedbacksList {...this.props} />
              </div>
            )}
          />
           <Route
            exact
            path="/home/feedbacks/response"
            render={({ history }) => (
              <div>
                <FeedbackLinkDetail {...this.props} />
              </div>
            )}
          />
            <Route
            exact
            path="/home/campaign/manage/:id"
            render={(params) => (
              <div>
                <CampaignManage {...this.props} {...params} />
              </div>
            )}
          />

          <Route
            exact
            path="/integration/templates/:providerName/:providerId"
            render={(params) => (
              <div>
                <Template {...this.props} {...params} />
              </div>
            )}
          />



          <Route
            exact
            path="/integration/loyalty/credentials-verify"
            render={({ history }) => (
              <div>
                <LoyaltyCredentials {...this.props} onHistory={history} />
              </div>
            )}
          />


          <Route
            exact
            path="/report"
            render={(params) => (
              <div>
                {this.props.isMobileApp() && (
                  <div className="report-back-bar">
                    <MobileTopBar {...this.props} {...params} showBack title="Reports" />
                  </div>
                )}
                <Report {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/integration/phonepe/credentials-verify"
            render={(params) => (
              <div>
                <PaymentCredentialsList {...this.props} {...params} />
              </div>
            )}
          />


          <Route
            exact
            path="/integration/whatsapp/credentials-verify"
            render={(params) => (
              <div>
                <CredentialVerify {...this.props} {...params} />
              </div>
            )}
          />

          <Route
            exact
            path="/excise"
            render={({ history }) => (
              <div>
                <RESettings {...this.props} onHistory={history} />
              </div>
            )}
          />
          <Route
            exact
            path="/salestransactionview/:key"
            render={(params) => (
              <div>
                <SalesTransactionView {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/s/:key"
            render={(params) => (
              <div>
                <SalesTransactionView {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/r/:key"
            render={(params) => (
              <div>
                <CaptureCustomerReferral {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/customerdisplay"
            render={(params) => (
              <div>
                <CustomerDisplay {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/pincodesignup"
            render={(history) => (
              <div>
                <PinCodeSignUpNew {...this.props} />
              </div>
            )}
          />

          <Route
            exact
            path="/home/pincode/pincodedashboard"
            render={(params) => (
              <div>
                <PincodeAdminDashboard {...this.props} {...params} />
              </div>
            )}
          />

          <Route
            exact
            path="/home/reports/pincodesmartmerchantdashboard"
            render={(params) => (
              <div>
                <PincodeSmartMerchantDashboard {...this.props} {...params} />
              </div>
            )}
          />

          <Route
            exact
            path="/home/reports/marginreport"
            render={(params) => (
              <div>
                <MarginReport {...this.props} {...params} />
              </div>
            )}
          />

          <Route
            exact
            path="/home/reports/notfoundingc"
            render={(params) => (
              <div>
                <PincodeNotFoundInGC
                  {...this.props}
                  {...params}
                  type="negative"
                />
              </div>
            )}
          />

          <AuthenticatedComponent {...this.props}>
            {/* {this.props.user.store && <Header {...this.props} />} */}
            {(this.props.user.store && !this.props.isMobileApp()) && <Menu {...this.props} />}
            {/* Phones: report detail pages have no header of their own; give
                them a back bar to the report list. Hub pages have their own. */}
            {this.props.isMobileApp() && (
              <Route
                path="/home/reports/:name"
                render={(params) =>
                  ["allreport", "download", "dashboard", "dashboardsettings"].includes(params.match.params.name)
                    ? null
                    : <div className="report-back-bar"><MobileTopBar {...this.props} {...params} showBack title="Reports" /></div>
                }
              />
            )}
            {!this.props.isMobileApp() && (
              <Route
                exact
                path="/home/settings/tables"
                render={(params) => (
                  <div>
                    <Tables {...this.props} {...params} />
                  </div>
                )}
              />
            )}
            {this.props.isMobileApp() && (
              <Route
                exact
                path="/home/settings/tables"
                render={(params) => (
                  <div>
                    <TablesNew {...this.props} {...params} />
                  </div>
                )}
              />
            )}
            <Route
              exact
              path="/home/inventory/whinbound/:key"
              render={(params) => (
                <div>
                  <InTransit {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/Packaging/:key"
              render={(params) => (
                <div>
                  <Packaging {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              path="/home/inventory/offersmartproducts"
              render={(params) => (
                <div>
                  <OfferSmartProducts {...this.props} {...params} />
                </div>
              )}
            />

            {/* <Route
            exact
            path="/home/inventory/whinbound"
            render={(params) => (
              <div>
                <div>
                  <ListPage {...this.props} {...params} type="whinbound" />
                </div>
              </div>
            )}
          /> */}
            <Route
              exact
              path="/home/inventory/whinbound"
              render={(params) => (
                <div>
                  <div>
                    <WHInboundList {...this.props} {...params} type="whinbound" />
                  </div>
                </div>
              )}
            />
         

           

            <Route
              exact
              path="/home/reports/categorywisetransaction"
              render={(params) => (
                <CategoryWiseTransactionReport {...this.props} {...params} />
              )}
            />
            <Route
              exact
              path="/home/reports/productexport"
              render={(params) => <ProductExport {...this.props} {...params} />}
            />
            <Route
              exact
              path="/home/reports/employeeincentive"
              render={(params) => (
                <div>
                  <EmployeeIncentiveReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/onlineorders"
              render={(params) => (
                <div>
                  <OmniTransactionCheck {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/appolineorders"
              render={(params) => (
                <div>
                  <OnlineOrdersInfinityApp {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/tables/new"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/tables/edit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/tableorder"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Table Order" />}
                  <TableOrder {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/settings"
              render={(params) => (
                <div>
                  <OmniSettings {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/missingpopularproducts"
              render={(params) => (
                <div>
                  <MissingPopularItems {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/product/pincodequickedit/"
              render={(params) => (
                <div>
                  <PincodeProductQuickEdit {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/product/pincodesmartproductoffers/"
              render={() => (
                <div>
                  <PincodeSmartProductOffer {...this.props} />
                </div>
              )}
            />

            {/* <Route
            exact
            path="/home/product/pincode"
            render={() => (
              <div>
                <ListPage {...this.props} type="pincodeproducts" />
              </div>
            )}
          />
          <Route
            exact
            path="/home/product/pincode/new"
            render={(params) => (
              <div>
                <ProductPincode {...this.props} {...params} />
              </div>
            )}
          />
          <Route
            exact
            path="/home/product/pincode/edit/:key"
            render={(params) => (
              <div>
                <ProductPincode {...this.props} {...params} />
              </div>
            )}
          /> */}
            <Route
              exact
              path="/home/product/quickedit/"
              render={(params) => (
                <div>
                  <ProductQuickEdit {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pendingapprovals/"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="pendingapprovals" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/onlinepaymenttransactions"
              render={(params) => (
                <div>
                  <ListPage
                    {...this.props}
                    {...params}
                    type="onlinepaymenttransactions"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/homesections/"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="omnihomesections" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/homesections/edit/:key"
              render={(params) => (
                <div>
                  <OmniHomeSectionEdit {...this.props} {...params} />{" "}
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/homesections/new"
              render={(params) => (
                <div>
                  <OmniHomeSectionEdit {...this.props} {...params} />{" "}
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/bulkpurchasereturn"
              render={(params) => (
                <div>
                  <BulkPurchaseReturn {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/productdetail"
              render={(params) => (
                <div>
                  <OmniProductDetailsPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/profile"
              render={(params) => (
                <div>
                  <OmniProfile {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/payment"
              render={(params) => (
                <div>
                  <OmniPayment {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/batchexpiryreport"
              render={(params) => (
                <div>
                  <BatchExpiryReport {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/KDS"
              render={(params) => (
                <div>
                  <KDS {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/kotcustomerdisplay"
              render={(params) => (
                <div>
                  <KOTCustomerDisplay {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/attendancereport"
              render={(params) => (
                <div>
                  <AttendanceReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/registration/additionalsettings"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/pincode/onlineproductsoutofstock"
              render={(params) => (
                <div>
                  <PincodeSoldOutOfStock
                    {...this.props}
                    {...params}
                    type="onlineorders"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/pincode/productsoutofstock"
              render={(params) => (
                <div>
                  <PincodeSoldOutOfStock {...this.props} {...params} type="" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/offers"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="offers" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/pages"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="omnipages" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/couponList"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="coupons" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/menus"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="omnimenus" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/menu/new"
              render={(params) => (
                <div>
                  <OmniMenu {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/menu/edit/:key"
              render={(params) => (
                <div>
                  <OmniMenu {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/offer"
              render={(params) => (
                <div>
                  <OfferReport {...this.props} {...params} type="offer" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/coupon"
              render={(params) => (
                <div>
                  <OfferReport {...this.props} {...params} type="coupon" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/offersummary"
              render={(params) => (
                <div>
                  <OfferSummaryReport {...this.props} {...params} type="offer" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/couponsummary"
              render={(params) => (
                <div>
                  <OfferSummaryReport {...this.props} {...params} type="coupon" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/vendors/"
              render={(params) => (
                <div>
                  <VendorList {...this.props} {...params} type="vendor" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/messagetemplates"
              render={() => (
                <div>
                  <ViewImageTemplates {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/messagetemplate/edit/"
              render={(params) => (
                <div>
                  <EditImageTemplate {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/customroles"
              render={() => (
                <div>
                  <CustomRoleList {...this.props} type="customroles" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/integration"
              render={() => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} title="Integration" />}
                  <Integration {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/onlineorders"
              render={(params) => (
                <div>
                  <FoodDeliveryOrders {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/intransit"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="In Transit" />}
                  <ViewIntransit {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/slider"
              render={() => (
                <div>
                  <ListPage {...this.props} type="omnisliders" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/omni/inquiries"
              render={(params) => (
                <div>
                  <ViewInquiries {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/crpaymentprovidersnewedit"
              render={(params) => (
                <div>
                  <CashRegisterPaymentProviderNewEdit
                    {...this.props}
                    {...params}
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/crpaymentproviders"
              render={(params) => (
                <div>
                  <CashRegisterPaymentProvider {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/crsettings"
              render={(params) => (
                <div>
                  <CashRegisterPrinterSettings {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/crlist"
              render={(params) => (
                <div>
                  <CashRegisterList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/crnew"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/credit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/businesscard"
              render={() => (
                <div>
                  <ViewBusinessCard {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/businesscard/edit"
              render={(params) => (
                <div>
                  <EditBusinessCard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/fooddeliveryplatformproducts"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Food Delivery Products" />}
                  <FoodDeliveryPlatformProducts {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/invoicedetail2"
              render={(params) => (
                <div>
                  <InvoiceDetail2 {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/gstr1transactionwise"
              render={(params) => (
                <div>
                  <GSTR1TransactionWise {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/gstr2transactionwise"
              render={(params) => (
                <div>
                  <GSTR2TransactionWise {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/gstr1b2b"
              render={(params) => (
                <div>
                  <GSTR1B2B {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/gstr1b2c"
              render={(params) => (
                <div>
                  <GSTR1B2C {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/hsnreport"
              render={(params) => (
                <div>
                  <HSNWiseReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/profitlossreport"
              render={(params) => (
                <div>
                  <ProfitLossReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/parkedtransactions/"
              render={(params) => (
                <div>
                  <ParkedTransaction {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/consumption"
              render={(params) => (
                <div>
                  <ProductConsumption {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/minqtyreport"
              render={(params) => (
                <div>
                  <MinQtyReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/maxqtyreport"
              render={(params) => (
                <div>
                  <MaxQtyReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/membershipdashboard"
              render={(params) => (
                <div>
                  <MembershipDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/inventoryhistory"
              render={(params) => (
                <div>
                  <InventoryHistory {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/productorderreport"
              render={(params) => (
                <div>
                  <ProductOrderReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/loyaltydashboard"
              render={(params) => (
                <div>
                  <LoyaltyDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/loyaltycustomer"
              render={(params) => (
                <div>
                  <LoyaltyByCustomer {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/loyaltyledger"
              render={(params) => (
                <div>
                  <LoyaltyLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/topcustomers"
              render={(params) => (
                <div>
                  <TopCustomers {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/transactionalsmstemplates/"
              render={(params) => (
                <div>
                  <TransactionSMSTemplateList
                    {...this.props}
                    {...params}
                    type="transactionalsmstemplates"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/promotionalsmstemplates/"
              render={(params) => (
                <div>
                  <MessageTemplateList
                    {...this.props}
                    {...params}
                    type="promotionalsmstemplates"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/cashregister/setup/"
              render={({ history }) => (
                <div>
                  <CashRegisterSetup {...this.props} onHistory={history} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/gstr2"
              render={(params) => (
                <div>
                  <GSTR2Report {...this.props} {...params} />
                </div>
              )}
            />
            {!this.props.isMobileApp() && (
              <Route
                exact
                path="/home/survey/"
                render={(params) => (
                  <div>
                    <ListPage {...this.props} {...params} type="survey" />
                  </div>
                )}
              />
            )}
            <Route
              exact
              path="/home/survey/new"
              render={(params) => (
                <div>
                  <Survey {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/survey/edit/:key"
              render={(params) => (
                <div>
                  <Survey {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/loyalty/loyaltytype"
              render={({ history }) => (
                <LoyaltyTypeList
                  {...this.props}
                  type="loyaltytype"
                />
              )}
            />
            <Route
              exact
              path="/home/loyalty/new"
              render={() => (
                <div>
                  <AddEditLoyalty {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/loyalty/edit/:key"
              render={(params) => (
                <div>
                  <AddEditLoyalty {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/loyalty/setup"
              render={(params) => (
                <div>
                  <LoyaltySetup {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/appointment"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Appointments" />}
                  <AppointmentView {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/appointments"
              render={(params) => (
                <div>
                  <AppointmentList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/appointment/create"
              render={(params) => (
                <div>
                  <CreateUpdateAppointment {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/appointment/edit"
              render={(params) => (
                <div>
                  <CreateUpdateAppointment {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/appointment/book"
              render={(params) => (
                <div>
                  <CreateAppointmentBooking {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home"
              render={({ history }) => (
                <Home {...this.props} onHistory={history} />
              )}
            />
            <Route
              exact
              path="/home/post"
              render={({ history }) => (
                <Posts {...this.props} onHistory={history} />
              )}
            />
            <Route
              exact
              path="/home/post/newpost"
              render={({ history }) => (
                <Post {...this.props} onHistory={history} />
              )}
            />
            <Route
              exact
              path="/home/settings/registration"
              render={() => <Registration {...this.props} />}
            />

            <Route
              exact
              path="/home/itemnotfoundinmastercatalogue"
              render={() => (
                <div>
                  <ListPage
                    {...this.props}
                    type="itemnotfoundinmastercatalogue"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/complaints"
              render={() => (
                <div>
                  <ListPage {...this.props} type="complaints" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/product"
              render={() => (
                <div>
                  <ProductList {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/products"
              render={() => (
                <div>
                  <ListPage {...this.props} type="products" />
                </div>
              )}
            />

            <Route
              exact
              path="/home/product/newproduct"
              render={() => (
                <div>
                  <Product {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/product/edit/:key"
              render={(params) => (
                <div>
                  <Product {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/tags"
              render={(params) => (
                <div>
                  <ProductGroupList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/offer"
              render={(params) => (
                <div>
                  <OfferList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/modifiers"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="modifier" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/lowstockreport"
              render={() => (
                <div>
                  <LowStockReport {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/outofstockreport"
              render={() => (
                <div>
                  <OutOfStockReport {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/customer/newcustomer"
              render={() => (
                <div>
                  <Customer {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/customer"
              render={() => (
                <div>
                  <CustomerList {...this.props} type="customer" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/m/customer/"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/customer/edit/:key"
              render={(params) => (
                <div>
                  <Customer {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/customer/customerdashboard/:key"
              render={(params) => (
                <div>
                  <CustomerDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/campaign"
              render={() => (
                <div>
                  <CampaignList {...this.props} type="campaign" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/coupons"
              render={(params) => (
                <div>
                  <CouponList {...this.props} {...params} type="coupons" />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/reportmanual"
              render={(params) => (
                <div>
                  <PincodeReportManual
                    {...this.props}
                    {...params}
                    type="negative"
                  />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/purchaseprojectionreport"
              render={(params) => (
                <div>
                  <PurchaseProjectionReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/reportedProducts"
              render={(params) => (
                <div>
                  <PincodeReportedProducts
                    {...this.props}
                    {...params}
                    type="negative"
                  />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/pincode/instockqty/1"
              render={(params) => (
                <div>
                  <PincodeInstockReport {...this.props} {...params} type="1" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/pincode/instockqty/0"
              render={(params) => (
                <div>
                  <PincodeInstockReport {...this.props} {...params} type="0" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/pincode/instockqty/negative"
              render={(params) => (
                <div>
                  <PincodeInstockReport
                    {...this.props}
                    {...params}
                    type="negative"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/inventorysalespurchaseinstock"
              render={(params) => (
                <div>
                  <InventoryPurchaseSalesInStock {...this.props} {...params} />
                </div>
              )}
            />

          

            <Route
              exact
              path="/home/reports/membershipexpiry"
              render={(params) => (
                <div>
                  <MembershipExpiry {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/newsales"
              render={(params) => (
                <div>
                  <Sales {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/sales"
              render={(params) => (
                <div>
                  <SalesIntermediate {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/receivepayment"
              render={(params) => (
                <div>
                  <ReceivePayment {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/packages/packagelist"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="packagelist" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/package/edit/:key"
              render={(params) => (
                <div>
                  <EditPackage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/saleslist"
              render={(params) => (
                <div>
                  <SalesHistory {...this.props} {...params} type="saleshistory" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/paybill"
              render={(params) => (
                <div>
                  <ListPage {...this.props} {...params} type="paybill" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/inventory"
              render={(params) => (
                <div>
                  <InventoryIntermediate {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/newinventory"
              render={(params) => (
                <div>
                  <Inventory {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/inventorylist"
              render={(params) => (
                <div>
                  <InventoryList {...this.props} {...params} type="inventorylist" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/intransit"
              render={(params) => (
                <div>
                  <InventoryInTransit
                    {...this.props}
                    {...params}
                    type="inventoryintransit"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/viewinventory/:key"
              render={(params) => (
                <div>
                  <ViewInventory {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/inventory/editinventory"
              render={(params) => (
                <div>
                  <Inventory {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/viewsales/:key"
              render={(params) => (
                <div>
                  <ViewSales {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/editsales/"
              render={(params) => (
                <div>
                  <Sales {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/salesreturn/"
              render={(params) => (
                <div>
                  <Sales {...this.props} {...params} />
                </div>
              )}
            />
            {/* {this.props.isMobileApp() && <Route path='/home/sales/deliverylist' render={(params) => (<div><DeliveryListNew {...this.props} {...params} /></div>)} />}
                {!this.props.isMobileApp() &&  */}
            <Route
              exact
              path="/home/sales/whatsapporders"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Online Orders" />}
                  <WhatsAppOrders {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              path="/home/sales/deliverylist"
              render={(params) => (
                <div>
                  <DeliveryList {...this.props} {...params} />
                </div>
              )}
            />
            {/* } */}
            <Route
              exact
              path="/home/sales/delivery/outfordelivery"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/cashregisterclosing/"
              render={(params) => (
                <div>
                  <CashRegisterClosing {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/sales/cashregisterclosinglist/"
              render={(params) => (
                <div>
                  <ListPage
                    {...this.props}
                    {...params}
                    type="cashregisterclosinglist"
                  />
                </div>
              )}
            />
              <Route
              exact
              path="/home/settings/saleschannel"
              render={(params) => (
                <div>
                  <SalesChannelList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/"
              render={(params) => (
                <div>
                  <StoreList {...this.props} {...params} type="store" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/locations/"
              render={(params) => (
                <div>
                  <LocationList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/locations/edit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/newstore/"
              render={(params) => (
                <div>
                  <AddEditStore {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/editstore/:key"
              render={(params) => (
                <div>
                  <AddEditStore {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/viewstoredetails/:key"
              render={(params) => (
                <div>
                  <ViewStoreDetails {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/"
              render={(params) => (
                <div>
                  <StaffList {...this.props} {...params} type="employeelist" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/mapping/"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/assignaccess/"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/changeaccess/"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/newemployee"
              render={(params) => (
                <div>
                  <AddEditEmployee {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/editemployee"
              render={(params) => (
                <div>
                  <AddEditEmployee {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/employees/viewemployeedetails"
              render={(params) => (
                <div>
                  <ViewEmployeeDetails {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/customfields"
              render={(params) => (
                <div>
                  <CustomFields {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/paymenttypes"
              render={(params) => (
                <div>
                  <PaymentTypeList {...this.props} {...params} type="paymenttypes" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/payments/new"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/payments/edit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/brands/edit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/brands/new"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/brands"
              render={() => (
                <div>
                  <BrandList {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/taxes"
              render={(params) => (
                <div>
                  <TaxesList {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/taxes/edit"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/taxes/new"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/category"
              render={() => (
                <div>
                  <CategoryList {...this.props} type="category" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/subcategory"
              render={() => (
                <div>
                  <SubCategoryList {...this.props} type="subcategory" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/editcategory"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/printtemplates"
              render={(params) => <PrintTemplateTypes {...this.props} {...params} />}
            />
            <Route
              exact
              path="/home/settings/printtemplates/:typeKey/gallery"
              render={(params) => <PrintTemplateGallery {...this.props} {...params} />}
            />
            <Route
              exact
              path="/home/settings/printtemplates/:typeKey/customize/:configKey"
              render={(params) => <PrintTemplateCustomize {...this.props} {...params} />}
            />
            {!this.props.isMobileApp() && (
              <Route
                exact
                path="/home/settings/stores/printconfig"
                render={(params) => (
                  <div>
                    <PrintConfigList {...this.props} {...params} />
                  </div>
                )}
              />
            )}
            {this.props.isMobileApp() && (
              <Route
                exact
                path="/home/settings/stores/printconfig"
                render={(params) => (
                  <div>
                    <PrintConfigListNew {...this.props} {...params} />
                  </div>
                )}
              />
            )}
            <Route
              exact
              path="/home/settings/stores/printconfig/newprintconfig"
              render={(params) => (
                <div>
                  <PrintConfig {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/printconfig/editprintconfig"
              render={(params) => (
                <div>
                  <PrintConfig {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/addtionalsettings"
              render={(params) => (
                <div>
                  <AddRegistrationSettings {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/pincodeintegrationsettings"
              render={(params) => (
                <div>
                  <PincodeIntegrationSettings {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/moduleconfig"
              render={(params) => (
                <div>
                  <ModuleConfigurationList {...this.props} {...params} type="moduleconfig" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/vendors/newvendor"
              render={(params) => (
                <div>
                  <AddEditVendor {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/vendors/edit/:key"
              render={(params) => (
                <div>
                  <AddEditVendor {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expenselist"
              render={() => (
                <div>
                  <ExpenseList {...this.props} type="expense" />
                </div>
              )}
            />

               <Route
              exact
              path="/home/helpdesk/tickets"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Tickets" />}
                  <TicketsList {...this.props} {...params} />
                </div>
              )}
            />
               <Route
              exact
              path="/home/helpdesk/configuration"
              render={(params) => (
                <div>
                  <HelpDeskConfiguration {...this.props} {...params} />
                </div>
              )}
            />
               <Route
              exact
              path="/home/helpdesk/type"
              render={(params) => (
                <div>
                  <HelpDeskTypeList {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expensecategorieslist"
              render={() => (
                <div>
                  <ExpenseCategoryList {...this.props} type="expensecategory" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expense/expensecategory/"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/salesdashboard"
              render={(params) => (
                <div>
                  <SalesDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/dashboard"
              render={(params) => (
                <div>
                  <Dashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/message"
              render={(params) => (
                <div>
                  <Message {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/dashboardsettings"
              render={(params) => (
                <div>
                  <DashboardSettings {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/sales/pincode/itemreport"
              render={(params) => (
                <div>
                  <PincodeItemReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/sales/pincode/orderreport"
              render={(params) => (
                <div>
                  <PincodeOrderReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/sales/pincode/customerreport"
              render={(params) => (
                <div>
                  <PincodeCustomerReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/sales/transaction"
              render={(params) => (
                <div>
                  <TransactionReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/newregistration"
              render={(params) => (
                <div>
                  <NewRegistration {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/sales/transactiondetail"
              render={(params) => (
                <div>
                  <InvoiceDetail {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/download"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Downloaded Reports" />}
                  <DownloadedReports {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/reports/itemsolddetail"
              render={(params) => (
                <div>
                  <ItemSoldReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/employeeitemdetail"
              render={(params) => (
                <div>
                  <EmployeeItemReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/categorywise"
              render={(params) => (
                <div>
                  <CategoryWiseDetail {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/brandwise"
              render={(params) => (
                <div>
                  <BrandWiseDetail {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/subcategorywise"
              render={(params) => (
                <div>
                  <SubCategoryWiseDetail {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/producttypewise"
              render={(params) => (
                <div>
                  <ProductTypeWise {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/allreport"
              render={(params) => (
                <div className="has-mobile-topbar">
                  {this.props.isMobileApp() && <MobileTopBar {...this.props} {...params} title="Reports" />}
                  <AllReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/employeedashboard"
              render={(params) => (
                <div>
                  <EmployeeDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/customereferencedetail"
              render={(params) => (
                <div>
                  <CustomerReferenceDetail {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/membership"
              render={() => (
                <div>
                  <MembershipList {...this.props} type="membership" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/attendancelist"
              render={() => (
                <div>
                  <AttendanceList {...this.props} type="attendance" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/expenseListreport"
              render={(params) => (
                <div>
                  <ExpenseListReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/expenseByExpenseCategoryreport"
              render={(params) => (
                <div>
                  <ExpenseByExpenseCategoryReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/expenseByPartyreport"
              render={(params) => (
                <div>
                  <ExpenseByPartyReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/Instock"
              render={(params) => (
                <div>
                  <Instock {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/ItemLedger"
              render={(params) => (
                <div>
                  <ItemLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/dailysales"
              render={(params) => (
                <div>
                  <DailySalesReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/monthlysales"
              render={(params) => (
                <div>
                  <MonthlySalesReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/paymentmodewise"
              render={(params) => (
                <div>
                  <PaymentModeWise {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/employeeworksheet"
              render={(params) => (
                <div>
                  <EmployeeWorkSheet {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/onBoarding"
              render={(params) => (
                <div>
                  <OnBoarding {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/paymentmodetransaction"
              render={(params) => (
                <div>
                  <PaymentModeTransactionTypeReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/gstr1"
              render={(params) => (
                <div>
                  <InvoiceDetail1 {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/report/inventoryreports"
              render={(params) => (
                <div>
                  <AllInventoryReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pincode/expiryverification"
              render={(params) => (
                <div>
                  <ExpiryVerification {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/pincode/enablesmart"
              render={(params) => (
                <div>
                  <PincodeWarehouseIntegration {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pincode/missingwhinbound"
              render={(params) => (
                <div>
                  <PincodeMissingWHInbound {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pincode/whreturn"
              render={(params) => (
                <div>
                  <WHReturn {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pincode/WHReturnItemsView/:key"
              render={(params) => (
                <div>
                  <WHReturnItemsView {...this.props} {...params} />
                </div>
              )}
            />

            <Route
              exact
              path="/home/pincode/whinboundverification"
              render={(params) => (
                <div>
                  <WHInboundVerification {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/pincode/whinboundverificationview"
              render={(params) => (
                <div>
                  <WHInboundVerificationView {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/customerwalletledger"
              render={(params) => (
                <div>
                  <CustomerWalletLedgerReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/customeroutstandingledger"
              render={(params) => (
                <div>
                  <CustomerOutstandingLedgerReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/reports/customerwalletledger"
              render={(params) => (
                <div>
                  <WalletLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/outstandingledger"
              render={(params) => (
                <div>
                  <OutStandingLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/uniqueno"
              render={(params) => (
                <div>
                  <UniqueNoReport {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/uniquenoledger"
              render={(params) => (
                <div>
                  <UniqueNoLedger {...this.props} {...params} />
                </div>
              )}
            />
             <Route
              exact
              path="/home/reports/machineledger"
              render={(params) => (
                <div>
                  <MachineTrackerLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/settings/stores/barcodesettings"
              render={(params) => (
                <div>
                  <BarcodePrintSettings {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/barcodeprint"
              render={(params) => (
                <div>
                  <BarcodePrint {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expense/accounts"
              render={(params) => (
                <div>
                  <AccountList {...this.props} {...params} type="account" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expense/addaccount"
              render={(params) => (
                <div>
                  <GenericRedirectPage {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expense/addtransaction"
              render={(params) => (
                <div>
                  <AddTransaction {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/expense/transactionlist"
              render={(params) => (
                <div>
                  <AccountManagementList
                    {...this.props}
                    {...params}
                    type="accountmanagement"
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/home/catalogue/bom"
              render={(params) => (
                <div>
                  <BomList {...this.props} {...params} type="bom" />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/vendorledgerreport"
              render={(params) => (
                <div>
                  <VendorLedger {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/reports/vendoroutstanding"
              render={(params) => (
                <div>
                  <VendorOutstanding {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/referral"
              render={(params) => (
                <div>
                  <CustomerReferralProgram {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/loyalty/loyaltydashboard"
              render={(params) => (
                <div>
                  <LoyaltyDashboard {...this.props} {...params} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/crm/campaignreport"
              render={() => (
                <div>
                  <CampaignsToRun {...this.props} />
                </div>
              )}
            />
            <Route
              exact
              path="/home/crm/campaigncustomers"
              render={() => (
                <div>
                  <CampaignToRunCustomers {...this.props} />
                </div>
              )}
            />
            {/* <Route
            exact
            path="/home/imageupload"
            render={(params) => (
              <div>
                <ProductImageUpload {...this.props} {...params} />
              </div>
            )}
          /> */}
            <Route
              exact
              path="/home/settings/customerdisplay"
              render={() => <CustomerDisplaySettings {...this.props} />}
            />
          </AuthenticatedComponent>
        </div>

        <NotificationBox
             {...this.props} 
          visible={this.state.showNotificationBox}
          data={this.state.notificationData}
          onStop={this.stopSound}
          onClose={this.onClose}
        />
      </>
    );
  }
}

export default Main;
